import { Component } from "./Component";
import { ComponentProps } from "./ComponentProps";
import { Container } from "./Container";

interface ComponentConstructor {
  new (props: ComponentProps): Component;
}

export function cloneComponent(component:Component, id?: string, overrideProps?, targetComponent?: Component, appendComponentId?: boolean, idCalcFunction?: ((id: string) => string)): Component {
  const sourceProps = getComponentPropertyValues(component);
  if (overrideProps != null)
    for (const key in overrideProps)
      sourceProps[key] = overrideProps[key];
  const sourceId = sourceProps.id;
  delete sourceProps.id;
  sourceProps._designer = component._designer;
  let result = targetComponent;
  if (idCalcFunction != null)
    sourceProps.id = idCalcFunction(sourceId);
  if (result == null) {
    const constr = component.constructor as ComponentConstructor;
    result = new constr(sourceProps);
  }
  if (component instanceof Container)
    for (const comp of component.components) {
      let id: string;
      if (idCalcFunction != null)
        id == idCalcFunction(comp.id);
      else if (appendComponentId === false)
        id = comp.id;
      else
        id = result.id + "-" + comp.id;
      (result as Container).add(cloneComponent(comp, id, null, null, appendComponentId, idCalcFunction));
    }
  result.owner = component.owner;
  return result;
}

function getComponentPropertyValues(component: Component): any {
  const result = {};
  const props = component.getPropertyDefinitions();
  for (const key in props) {
    const value = component[key];
    if (value !== undefined)
      result[key] = component[key];
  }
  return result;
}
